<template>
    <div>
        <div v-if="!selectedLawyer" class="range-box">
            <veui-button
                ui="l basic"
                @click="() => (selectedLawyerOpen = true)"
            >
                + 选择律师
            </veui-button>
            <div class="tips">仅能选择尊享、精英会员且在会员有效期内的律师</div>
        </div>
        <div v-else class="selected-lawyer">
            {{ selectedLawyer.name }}（{{ selectedLawyer.phone }}）
            <span @click="() => (selectedLawyerOpen = true)">修改</span>
        </div>
        <veui-dialog
            title="客户律师列表"
            ui="wide"
            :open.sync="selectedLawyerOpen"
        >
            <div class="selected-top">
                <div class="selected-top-text">
                    仅能选择尊享、精英会员且在会员有效期内的律师
                </div>
                <veui-search-box
                    ui="strong"
                    placeholder="查找律师"
                    @search="lawyerSearch"
                />
            </div>
            <veui-table
                :data="tableData"
                :scroll="{x: 714}"
                role="columnheader"
                :loading="isLoading"
                key-field="id"
                selectable
                select-mode="single"
                :selected.sync="selectedLawyerId"
            >
                <veui-table-column
                    field="name" title="律师姓名"
                    width="80"
                >
                    <template #default="{name}">
                        <div class="table-name">{{ name }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="codeType"
                    title="会员类型"
                    width="100"
                >
                    <template #default="{codeType}">
                        <div class="table-name">{{ memberType[codeType] || '-' }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="phone" title="律师手机号"
                    width="100"
                >
                    <template #default="{phone}">
                        {{ phone || "-" }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="cityName" title="执业城市"
                    width="80"
                >
                    <template #default="{cityName}">
                        {{ cityName | cityNameCol }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="endTime" title="结束日期"
                    width="150"
                >
                    <template #default="{endTime, disabled}">
                        {{ endTime
                        }}<span class="end-time">{{
                            disabled ? "(即将到期)" : ""
                        }}</span>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="license"
                    title="执业资格证号"
                    width="180"
                />
            </veui-table>
            <!-- 分页 -->
            <veui-pagination
                v-if="tableData && tableData.length"
                :page="pn"
                :page-size="rn"
                :total="count"
                class="selected-lawyer-pagination"
                @redirect="pageChange"
            />
            <template #foot>
                <div class="selected-lawyer-footer">
                    <veui-button
                        ui="l strong"
                        @click="() => (selectedLawyerOpen = false)"
                    >
                        取消
                    </veui-button>
                    <veui-button ui="l primary" @click="addLawyer">
                        添加律师
                    </veui-button>
                </div>
            </template>
        </veui-dialog>
    </div>
</template>

<script>
/**
 * @file lawyer-selector.vue
 * @desc 客户律师选择器
 * @author
 */

import {mapState} from 'vuex';
import {Button, SearchBox, Table, Column, Pagination, Dialog} from 'veui';
export default {
    name: 'lawyerSelector',
    components: {
        'veui-button': Button,
        'veui-search-box': SearchBox,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        'veui-dialog': Dialog
    },
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        // 不可选的会员到期前天数
        disabledDays: {
            type: Number,
            default: 7
        }
    },
    data() {
        return {
            selectedLawyer: null,
            selectedLawyerId: 0,
            selectedLawyerOpen: false,
            isLoading: false,
            pn: 1,
            rn: 10,
            tableData: [],
            count: 0,
            fid: '',
            memberType: {
                0: '尊享会员',
                8: '精英会员'
            }
        };
    },
    filters: {
        cityNameCol(value) {
            const cityName = (value && value.split('$')) || [];
            return (cityName && cityName[cityName.length - 1]) || '-';
        }
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew
        })
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.id) {
                    this.selectedLawyer = newVal;
                    this.selectedLawyerId = newVal.id;
                }
            }
        },
        userInfoNew: {
            deep: true,
            immediate: true,
            handler(newVal, oldVal) {
                let firm_info = newVal?.law_firm_info || newVal?.law_firm_subaccount || {};
                this.fid = firm_info?.id || '';
                this.fid && this.getTableData();
            }
        }
    },
    methods: {
        addLawyer() {
            this.selectedLawyerOpen = false;
            const lawyer = this.tableData.filter(
                item => this.selectedLawyerId === item.id
            );
            if (!lawyer.length) {
                return;
            }
            this.selectedLawyer = lawyer[0];
            this.$emit('input', lawyer[0]);
            this.$emit('change', lawyer[0]);
        },

        /**
         * 获取表格数据
         */

        getTableData(value = {}) {
            this.isLoading = true;
            let params = {
                fid: this.fid,
                codeType: '0,8',
                orderBindTime: '0',
                orderValidityStartTime: '0',
                orderValidityEndTime: '0',
                type: 0, // 全部
                ...value,
                pn: this.pn,
                rn: this.rn
            };
            this.$http
                .get('/bp/crm/getcustomerlist', {
                    params
                })
                .then(res => {
                    this.isLoading = false;
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        this.tableData = [];
                        return;
                    }
                    let list = data?.list || [];
                    list = list.map(item => {
                        if (!item.validityEnd) {
                            return item;
                        }
                        const disabledTime
                            = (this.disabledDays || 0) * 1000 * 3600 * 24;
                        const time = new Date(item.validityEnd * 1000);
                        let y = time.getFullYear();
                        let m = time.getMonth() + 1;
                        let d = time.getDate();
                        item.endTime = y + '-' + m + '-' + d;
                        if (
                            item.validityEnd * 1000 - new Date().getTime()
                            < disabledTime
                        ) {
                            item.disabled = true;
                        }
                        return item;
                    });
                    this.tableData = list;
                    this.count = data?.count || 0;
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isLoading = false;
                });
        },
        /**
         * 搜索律师名称
         */

        lawyerSearch(e) {
            this.getTableData({
                name: e || ''
            });
        },

        /**
         * 页面改变
         */

        pageChange(pn) {
            this.pn = pn;
            this.getTableData();
        }
    }
};
</script>

<style lang="less" scoped>
.range-box {
    position: relative;

    /deep/ .veui-button {
        color: #999;
    }

    .range-box-tip {
        position: absolute;
        left: 300px;
        top: 0;
        width: 500px;
        padding-left: 24px;
    }

    .tips {
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #9d9d9d;
        line-height: 12px;
        font-weight: 400;
        margin-top: 12px;
    }
}

.selected-lawyer {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #000;
    line-height: 14px;
    font-weight: 400;

    span {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #404eff;
        line-height: 14px;
        font-weight: 400;
        cursor: pointer;
    }
}

.selected-top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    .selected-top-text {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #999;
        letter-spacing: 0;
        font-weight: 400;
    }

    .veui-input-group {
        border: 1px solid #d3d9e6;
    }

    .veui-button[ui~="primary"] {
        background: none;
        color: #999;
    }

    .veui-input {
        border: none;
        box-shadow: none;
    }
}

.selected-lawyer-pagination {
    float: right;
    padding-top: 30px;

    .veui-pagination-total {
        display: block;
    }

    .veui-pagination-size {
        display: none;
    }
}

.selected-lawyer-footer {
    display: flex;
    justify-content: center;
}

.end-time {
    color: #fa6400;
}
</style>